export const stateDropdownQuery = `
  query AllStates($name: String) {
    allStates(name_Icontains:$name, first: 5) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const questionnaireStateDropdownQuery = `
  query QueastionnaireStates($name: String) {
    questionnaireStates(name_Icontains:$name) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const townDropdownQuery = `
query AllTowns($name: String, $selectedState: ID, $stateList: ID){
  allTowns(
    name_Icontains:$name,
    districtid_Stateid:$selectedState,
    first:10,
    districtid_Stateid_Name_In: $stateList,
    orderBy: "name",
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
        retailerCount
        assigned
        lastCallDate
      }
    }
  }
}
`;

export const areaDropdownQuery = `
  query AllAreas($name: String, $selectedTown: ID, $townList: ID){
    allAreas(name_Icontains:$name, townid: $selectedTown, townid_Name_In: $townList) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          name
          retailerCount
          assigned
          lastCallDate
        }
      }
    }
  }
`;

export const userDetailDropdownQuery = `
query AllUser(
  $name: ID,
  $userType: String,
  $supervisorId: ID,
) {
  allUserDetails(
    employee_Name_Icontains: $name,
    userType_In: $userType,
    supervisorId: $supervisorId,
    first: 5
  ) {
    edges {
      node {
        id
        employee {
          id
          name
          noOfWorksPending
          startDateForNextWork
        }
        supervisor{
          id
          employee{
            id
            name
          }
        }
      }
    }
  }
}
`;

export const productDropdownQuery = `
query ProductDropdowQuery($name: String) {
  allProducts(name_Icontains: $name, first: 10) {
    edges {
      node {
        id
        name
        currentcasesize
      }
    }
  }
}
`;

// emailid is selected so Email Settings can refuse to add a recipient who has
// no address: the completion report builds its recipient list straight from
// these employees, and one null address fails the whole send -- for everyone
// on the list, not just that person.
export const employeeDropdownQuery = `
  query AllEmployees($name: String) {
    allEmployees(name_Icontains: $name, first: 10) {
      edges {
        node {
          id
          name
          emailid
        }
      }
    }
  }
`;

export const userDropdownQuery = `
query AllUsers($name: String) {
  allUsers(username_Icontains: $name) {
    edges {
      node {
        id
        username
      }
    }
  }
}
`;

export const retailerDropdown = `
  query retailerDropdown(
    $name: String
  ){
    allRetailers(firm_Icontains: $name, first: 5, active: true){
      edges{
        node{
          id
          firm
        }
      }
    }
  }
`;
